export default "__VITE_ASSET__8b7f4f33__"